/* Copyright (c) 2018 Scaper */

import { UserInfo } from "@firebase/auth-types";
import * as React from "react";
import { Elements } from "react-stripe-elements";
import { CloseButton } from "../modal/closeButton";
import { CardForm } from "./cardForm";

interface IProps {
    userInfo: UserInfo;
}

export class AddPaymentMethod extends React.PureComponent<IProps, {}> {
    public render() {
        const { userInfo } = this.props;
        const { displayName } = userInfo;
        return (
            <>
                <h2>
                    Add Payment Method

                    <CloseButton />
                </h2>

                <div className="divider"></div>

                <div className="section">
                    Please enter credit card details

                    <Elements>
                        <CardForm />
                    </Elements>
                </div>
            </>
        );
    }
}
